import {
  EVENT_CREATED,
} from '../actions/event/async'

export default function event(state = {
  allEvents: [],
  event: {},
  presentations: []
}, action) {
  switch (action.type) {
    case EVENT_CREATED:
      return state
    case "EVENTS_FETCHED":
      return Object.assign({}, state, {
        allEvents: action.payload.events,
        event: {}
      })
    case "EVENT_FETCHED":
      return Object.assign({}, state, {
        event: action.payload.event
      })
    case "EVENT_EMAIL_UPDATED":
      return Object.assign({}, state, {
        event: action.payload
      })
    case "PRESENTATION_FILE_ADDED":
    case "PRESENTATION_PRIVACY_CHANGED":
      return Object.assign({}, state, {
        presentations: state.presentations.map((p) => {
          return p._id === action.payload.presentation._id ? action.payload.presentation : p
        })
      })
    case "EVENT_PRESENTATIONS_FETCHED":
      return Object.assign({}, state, {
        event: action.payload.data.event,
        presentations: action.payload.data.presentations
      })
    default:
      return state
  }
}
